import { useState } from "react";

type Props = {
  title: string;
  subtitle?: string;
  defaultOpen?: boolean;
  accent?: string;
  rightSlot?: React.ReactNode;
  children: React.ReactNode;
};

export default function Section({
  title,
  subtitle,
  defaultOpen = false,
  accent = "#0069d9",
  rightSlot,
  children,
}: Props) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <section
      style={{
        background: "white",
        borderRadius: "0.6rem",
        boxShadow: "0 1px 3px rgba(0,0,0,.04)",
        borderLeft: `3px solid ${accent}`,
        marginBottom: "0.75rem",
        overflow: "hidden",
      }}
    >
      <header
        onClick={() => setOpen((v) => !v)}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "0.75rem",
          padding: "0.7rem 1rem",
          cursor: "pointer",
          background: open ? "#f8f9fb" : "white",
          borderBottom: open ? "1px solid #f1f3f5" : "none",
        }}
      >
        <span
          aria-hidden
          style={{
            display: "inline-block",
            width: 0,
            height: 0,
            borderLeft: "5px solid transparent",
            borderRight: "5px solid transparent",
            borderTop: open ? `5px solid ${accent}` : "none",
            borderBottom: open ? "none" : `5px solid transparent`,
            transform: open ? "none" : "rotate(-90deg)",
            transition: "transform 120ms ease",
          }}
        >
          {!open && (
            <span
              style={{
                display: "inline-block",
                width: 0,
                height: 0,
                borderLeft: "5px solid transparent",
                borderRight: "5px solid transparent",
                borderTop: `5px solid ${accent}`,
                transform: "rotate(-90deg)",
              }}
            />
          )}
        </span>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              fontSize: ".82rem",
              fontWeight: 600,
              color: "#1f2933",
              textTransform: "uppercase",
              letterSpacing: ".4px",
            }}
          >
            {title}
          </div>
          {subtitle && (
            <div style={{ fontSize: ".72rem", color: "#73879C" }}>
              {subtitle}
            </div>
          )}
        </div>
        {rightSlot && (
          <div onClick={(e) => e.stopPropagation()}>{rightSlot}</div>
        )}
      </header>
      {open && <div style={{ padding: "0.9rem 1rem 1rem" }}>{children}</div>}
    </section>
  );
}
